// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import { Loader as MapLoader } from '@googlemaps/js-api-loader';
import mapStyles from './_mapStyles';
import { forEach as _forEach } from 'lodash-es';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------
const { googleData } = window;

const mapLoader = new MapLoader({
  apiKey: googleData.apiKey,
  version: 'weekly',
});

const baseClass = 'google';
var markers = [];
var iterator = 0;
let iconPath = '';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class LocationMap {
  constructor(el) {
    this.waypoint = null;
    this.gm = null;
    this.map = null;
    this.coords = null;
    this.center = null;
    this.infoWindow = null;
    this.el = el;
    this.mapMarker = $(el).find('.block-map-marker');
    this.$infoWindowContent = $(el).find(`.${baseClass}__info-window-content`);
    this.$inner = $(el).find(`.${baseClass}__inner`);
    this.markers = [];
    this.outher = $(el).find(`.${baseClass}__outer`);

    this.initWaypoint(el);
  }

  createMarker() {
    _forEach(this.mapMarker, (item, index) => {
      this.coords = {
        lat: parseFloat(item.dataset.lat),
        lng: parseFloat(item.dataset.lng),
      };

      $(item).attr('data-marker-id', `marker-${parseInt(index + 1)}`);

      let isActive = false;

      iconPath = item.dataset.marker.replace('map-marker-black.png', '');
      if (item.dataset.main === 'true') {
        isActive = true;
      }

      let marker = new google.maps.Marker({
        id: `marker-${parseInt(index + 1)}`,
        isMain: isActive,
        position: this.coords,
        map: this.map,
        icon: item.dataset.marker,
        draggable: false,
      });

      markers.push(marker);

      window.google.maps.event.addListener(marker, 'click', function () {
        let currentIcon = marker.icon;

        if (currentIcon.includes('red')) {
          return;
        }

        _forEach(markers, (item) => {
          if (item.isMain === true) {
            item.set('icon', `${iconPath}/map-marker-black-big.png`);
          } else {
            item.set('icon', `${iconPath}/map-marker-black.png`);
          }
        });

        if (currentIcon.includes('black-big')) {
          this.set('icon', `${iconPath}/map-marker-red-big.png`);
        } else {
          this.set('icon', `${iconPath}/map-marker-red.png`);
        }

        $(`.${baseClass}`).find(`[data-marker-id]`).removeClass('is-active');
        $(`.${baseClass}`).find(`[data-marker-id="${marker.id}"]`).addClass('is-active');
      });

      $(item).click(function () {
        let currentID = $(this).attr('data-marker-id');

        if ($(this).hasClass('is-active')) return;

        $(`.${baseClass}`).find(`[data-marker-id]`).removeClass('is-active');
        $(this).addClass('is-active');

        _forEach(markers, (item) => {
          if (item.id != currentID) {
            if (item.isMain === true) {
              item.set('icon', `${iconPath}/map-marker-black-big.png`);
            } else {
              item.set('icon', `${iconPath}/map-marker-black.png`);
            }
          } else if (item.isMain === true) {
            item.set('icon', `${iconPath}/map-marker-red-big.png`);
          } else {
            item.set('icon', `${iconPath}/map-marker-red.png`);
          }
        });
      });

      iterator++;
    });
  }

  mapCenter() {
    _forEach(this.mapMarker, (item) => {
      if (item.classList.contains('is-center')) {
        this.center = {
          lat: parseFloat(item.dataset.lat),
          lng: parseFloat(item.dataset.lng),
        };
      }
    });
  }

  initWaypoint(el) {
    this.waypoint = new IntersectionObserver((o) => {
      if (o[0].isIntersecting) {
        this.initMap(el);
        this.waypoint.disconnect();
      }
    }, {
      rootMargin: '125% 0px',
      threshold: 0,
    });
    this.waypoint.observe(this.el);
  }

  initMap() {
    mapLoader.load().then(() => {
      if (this.outher.length >= 1) {
        this.gm = window.google.maps;

        this.mapCenter();
        this.map = new this.gm.Map(this.$inner[0], {
          center: this.center,
          zoom: 11,
          disableDefaultUI: true,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          styles: mapStyles,
        });

        this.createMarker();
      }
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new LocationMap(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
